import { render, staticRenderFns } from "./VirtualWalletContent.vue?vue&type=template&id=1ac09c4a&"
import script from "./VirtualWalletContent.vue?vue&type=script&lang=js&"
export * from "./VirtualWalletContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports